import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MainLayout from '../layouts/MainLayout';
import ClientForm from '../pages/ClientForm';
import Vendors from '../pages/Vendors';
import VendorDetails from '../pages/VendorDetails';


import LoginPage    from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import Dashboard    from '../pages/Dashboard';
import Clients      from '../pages/Clients';
import ClientDetail from '../pages/ClientDetail';
import Projects     from '../pages/Projects';
import ProjectDetail from "../pages/ProjectDetail";
import Tasks        from '../pages/Tasks';
import Payments     from '../pages/Payments';
import Attendance   from '../pages/Attendance';
import ActivityLogs from '../pages/ActivityLogs';
import QuoteEditor from '../pages/QuoteEditor';
import Quotation    from "../pages/Quotation";
import QuotationList from "../pages/QuotationList"; // 🔥 NEW
import ItemMaster   from '../pages/ItemMaster';
import MaterialMaster from "../pages/MaterialMaster";
import Inventory from "../pages/Inventory";
import Settings     from '../pages/Settings';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return !user ? children : <Navigate to="/dashboard" replace />;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return user.role === 'admin' ? children : <Navigate to="/dashboard" replace />;
}

export default function AppRoutes() {
  return (
    <Routes>

      {/* PUBLIC ROUTES */}
      <Route path="/login" element={
        <PublicRoute><LoginPage /></PublicRoute>
      } />

      <Route path="/register" element={
        <AdminRoute><MainLayout /></AdminRoute>
      }>
        <Route index element={<RegisterPage />} />
      </Route>

      {/* PRIVATE ROUTES */}
      <Route element={
        <PrivateRoute><MainLayout /></PrivateRoute>
      }>

        <Route path="/dashboard"  element={<Dashboard />} />
        <Route path="/clients"    element={<Navigate to="/projects" replace />} />
        <Route path="/projects"   element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/tasks"      element={<Tasks />} />
        <Route path="/payments"   element={<Payments />} />
        <Route path="/activity"   element={<ActivityLogs />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/clients/new" element={<Navigate to="/projects" replace />} />
        <Route path="/clients/:id" element={<Navigate to="/projects" replace />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/vendors/:id" element={<VendorDetails />} />


        {/* QUOTE EDITOR */}
        <Route path="/quote-editor" element={<QuoteEditor />} />
        <Route path="/quote-editor/:quoteId" element={<QuoteEditor />} />

        {/*  QUOTATION ROUTES */}
        <Route path="/quotations" element={<QuotationList />} />
        <Route path="/quotations/new" element={<Quotation />} />

        <Route path="/item-master" element={<ItemMaster />} />
        <Route path="/material-master" element={<MaterialMaster />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/settings"    element={<Settings />} />

      </Route>

      {/* FALLBACK */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />

    </Routes>
  );
}
